import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Tab,
    TextField,
} from "@mui/material";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import CustomDialog from "../../../components/CustomDialog/CustomDialog.tsx";
import itemImg from "./../../../../assets/icons/sections.png";
import Cancel from "./../../../../assets/icons/close.png";
import { TabContext, TabList } from "@mui/lab";
import MainFoodItemTab from "./MainFoodItemTab.tsx";
import LinkedFoodItemTab from "./LinkedFoodItemTab.tsx";
import axios from "axios";

const EditRankDialog = (props) => {
    const apiAddress = process.env.REACT_APP_SECRET;
    const [
        openSectionCloseConfirmaitonModal,
        setopenSectionCloseConfirmaitonModal,
    ] = useState(false);

    const [linkedFoodItems, setLinkedFoodItems] = useState([]);
    const [mainFoodItem, setMainFoodItem] = useState({});
    const [mainRankOptions, setMainRankOptions] = useState([]);
    const [linkedRankOptions, setLinkedRankOptions] = useState([]);

    const handleClose = () => {
        props.onHandleAddItem(false);
        setopenSectionCloseConfirmaitonModal(false);
    };

    const { dialogType, foodItemId } = props;

    console.log(foodItemId)

    //dialog  start
    const [openDialog, setOpenDialog] = useState(false);

    const handleDialog = (DialogData) => {
        setOpenDialog(DialogData);
    };

    const [value, setValue] = useState("1")

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(()=>{
        //ok

        // const getLinkedRankOptions = async ()=>{
        //     try {
        //         const response = await axios.get(`${apiAddress}/api/FoodItems/GetRankListLinkedFoodItemByFoodItemId?id=eee96dbc-fc90-4106-88f7-77572b3f6642`);
        //         setLinkedRankOptions(response.data);
        //     } catch (error) {
                
        //     }
        // }
        getMainFoodItem();
        getLinkedFoodItem();
        //getMainRankOptions();
    }, [foodItemId]);

    useEffect(()=>{
        getMainRankOptions();
    }, [mainFoodItem]);

    const getMainFoodItem = async ()=>{
        try {
            const response = await axios.get(`${apiAddress}/api/FoodItems/GetFoodItemAndRankByFoodItemId?id=${foodItemId}`);
            setMainFoodItem(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const getLinkedFoodItem = async ()=>{
        try {
            const response = await axios.get(`${apiAddress}/api/FoodItems/GetAllLinkedFoodItemAndRankByFoodItemId?id=${foodItemId}`);          
            setLinkedFoodItems(response.data);
        } catch (error) {
            console.log(error);
        }
    }
    // ok
    const getMainRankOptions = async ()=>{
        try {
            const response = await axios.get(`${apiAddress}/api/FoodItems/GetRankListBySectionId?id=${mainFoodItem?.sectionId}`);
            setMainRankOptions(response.data);
        } catch (error) {
            
        }
    }
    return (
        <div>
            <React.Fragment>
                <Dialog
                    className="addSectionDialog"
                    open={props.open}
                    onClose={handleClose}
                >
                    <SweetAlertModal
                        headerText={"Do you want to leave without saving?"}
                        bodyText={"All changes made will be lost"}
                        open={openSectionCloseConfirmaitonModal}
                        onyes={handleClose}
                        close={() => {
                            setopenSectionCloseConfirmaitonModal(false);
                        }}
                        id={2}
                    />
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>
                                <div className="d-flex" style={{ gap: "8px" }}>
                                    <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div>

                                    <span style={{ color: "#2a7fd4" }}>
                                        GoTaste :- {dialogType}
                                    </span>
                                </div>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button
                                    onClick={() => setopenSectionCloseConfirmaitonModal(true)}
                                >
                                    <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
                        <div>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                    >
                                        <Tab label="Main Food Item" value="1" />
                                        <Tab label="Linked Food Item" value="2" />

                                    </TabList>
                                </Box>
                            </TabContext>
                        </div>

                        <div className={`${value == '1' ? "d-block " : "d-none"} `}>
                            <MainFoodItemTab 
                            mainFoodItem={mainFoodItem}
                            setMainFoodItem={setMainFoodItem}
                            mainRankOptions={mainRankOptions}
                            />
                        </div>

                        <div className={`${value == '2' ? "d-block " : "d-none"} `}>
                            <LinkedFoodItemTab 
                            linkedFoodItems={linkedFoodItems} 
                             />
                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
            <CustomDialog
                open={openDialog}
                dialogTitle={"Add Icon"}
                onClose={handleDialog}
            />
        </div>
    );
};

export default EditRankDialog;